(function () {
  'use strict';

  var dataEl = document.getElementById('community-data');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent || dataEl.innerText || '{}');
  } catch (err) {
    console.warn('[community] Failed to parse #community-data JSON:', err);
    return;
  }

  var status = data.status;
  var orderingActive = status !== 'closed' && status !== 'fulfilled' && status !== 'cancelled';

  // 0. Market auto-switch (D6, docs/INTL_COMMUNITIES_PLAN.md §WS2.4).
  // Each community is locked to exactly one market (D2): its discount code
  // only redeems in that market's currency. If the visitor's session is in a
  // different market (URL-subfolder-based on this store), send them to the
  // community's locale-prefixed URL — same mechanism as the theme's currency
  // switcher (assets/currency-switcher.js switchMarket()), including its
  // ?country= query-param fallback for dev/theme-preview where subfolder
  // URLs don't resolve market context.
  //
  // currency_code is blank/null on legacy communities ⇒ treated as USD, so a
  // legacy page visited under /en-ca/… redirects to the root (US) URL —
  // which also fixes the legacy quirk where CAD visitors saw a CAD price
  // minus the hardcoded USD cents.
  //
  // Loop guard: sessionStorage remembers the currency we last auto-switched
  // for. If we land back on the page still mismatched (market unavailable,
  // redirect failed), we don't redirect again. The guard clears as soon as a
  // page load sees matching currencies, so later legitimate switches work.
  function switchToCommunityMarket(targetCurrency) {
    // Currency → country and country → locale mappings mirror
    // assets/currency-switcher.js switchMarket().
    var currencyToCountry = { USD: 'US', CAD: 'CA', AUD: 'AU', NZD: 'NZ', GBP: 'GB' };
    var countryToLocale = { US: 'en-us', CA: 'en-ca', AU: 'en-au', NZ: 'en-nz', GB: 'en-gb' };
    var countryCode = currencyToCountry[targetCurrency] || 'US';
    var locale = countryToLocale[countryCode];

    var isLocalDev =
      window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    var isPreviewMode = window.location.search.includes('preview_theme_id');

    if (isLocalDev || isPreviewMode) {
      // ?country=XX 301-redirects to the market's canonical (locale-prefixed)
      // URL and survives preview mode, where building the subfolder URL by
      // hand wouldn't carry the preview session correctly.
      var url = new URL(window.location.href);
      url.searchParams.set('country', countryCode);
      window.location.replace(url.toString());
      return;
    }

    // Strip any existing locale prefix, then re-add the target one (US lives
    // at the root, no prefix).
    var currentPath = window.location.pathname;
    var localePattern = /^\/(en-us|en-ca|en-au|en-nz|en-gb)(\/|$)/i;
    currentPath = currentPath.replace(localePattern, '/');
    var newPath = locale === 'en-us' ? currentPath : '/' + locale + currentPath;
    // location.replace (not href) so the wrong-market page doesn't enter
    // history — back button would otherwise bounce straight into a redirect.
    window.location.replace(newPath + window.location.search);
  }

  var communityCurrency = data.currency_code || 'USD'; // blank ⇒ legacy ⇒ USD (D10)
  var activeCurrency =
    data.page_currency ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    null;
  var GUARD_KEY = 'cm-market-autoswitch';
  var redirecting = false;
  if (activeCurrency && activeCurrency !== communityCurrency) {
    var guard = null;
    try { guard = sessionStorage.getItem(GUARD_KEY); } catch (err) { /* storage unavailable */ }
    if (guard === communityCurrency) {
      console.warn(
        '[community] session currency ' + activeCurrency + ' still does not match community currency ' +
        communityCurrency + ' after an auto-switch attempt; not redirecting again (loop guard).'
      );
    } else {
      try { sessionStorage.setItem(GUARD_KEY, communityCurrency); } catch (err) { /* ignore */ }
      redirecting = true;
      switchToCommunityMarket(communityCurrency);
    }
  } else if (activeCurrency) {
    try { sessionStorage.removeItem(GUARD_KEY); } catch (err) { /* ignore */ }
  }

  // 1. Apply the discount cookie by hitting /discount/<code>.
  // Shopify's discount permalink sets the cookie even when fetched.
  // We use redirect:'manual' and mode:'no-cors' to avoid following the redirect
  // and to suppress CORS-related noise — we only care about the cookie side effect.
  // Skipped while a market auto-switch redirect is in flight: the cookie must
  // be set AFTER the session is in the community's market (it will fire on
  // the post-redirect page load instead).
  if (!redirecting && orderingActive && data.discount_code) {
    fetch('/discount/' + encodeURIComponent(data.discount_code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual',
      mode: 'no-cors'
    }).catch(function (err) {
      console.warn('[community] Failed to apply discount cookie:', err);
    });
  }

  // 2. Neutralize the Koala-bundler ATC hijack from flash-forward.js.
  // flash-forward.js attaches a click listener to .flash-forward__button-cart
  // that preventDefault()s and runs its own /cart/add.js fetch. On the
  // community page we want the standard form submission to /cart/add instead,
  // so the discount-code cookie applies cleanly at checkout.
  //
  // Capture-phase stopImmediatePropagation guarantees no other click listener
  // on the button — regardless of when or how it was attached — can fire.
  // Default form submission still proceeds because we don't preventDefault().
  document.addEventListener('DOMContentLoaded', function () {
    var atcBtn = document.querySelector('.flash-forward__button-cart');
    if (!atcBtn) return;
    atcBtn.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
    }, true);
  });

  // 3. Keep the form's hidden variant id in sync with the selected color swatch.
  // flash-forward.js updates its own internal selectedVariantId on swatch clicks
  // but never writes it back to <input name="id">, so without this the form
  // always submits the page-load default variant (Answer Me Aquamarine).
  document.addEventListener('DOMContentLoaded', function () {
    var swatches = document.querySelectorAll('.flash-forward_colors-button');
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!swatches.length || !idInput) return;
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) idInput.value = variantId;
      });
    });
  });

  // 4. Live countdown on the progress box. Replaces the initial Liquid-rendered
  // fallback ("Ordering closes Jul 15, 2026") with either "N days left to
  // order!" (until the calendar day of close) or "HH:MM left to order!" (on
  // the closing day). Ticks every 30 seconds. If JS doesn't load, the
  // fallback text stays visible.
  //
  // The day-vs-time flip is based on calendar date comparison in the viewer's
  // local timezone, not a 24-hour rule — so "the day of close" lines up with
  // the viewer's actual day, and the format swaps at local midnight.
  function updateCommunityCountdown(el) {
    var iso = el.getAttribute('data-window-closes-at');
    if (!iso) return;
    var target = new Date(iso);
    if (isNaN(target.getTime())) return;
    var now = new Date();
    var diffMs = target.getTime() - now.getTime();
    if (diffMs <= 0) {
      el.textContent = 'Order window has closed.';
      return;
    }
    var sameDay =
      target.getFullYear() === now.getFullYear() &&
      target.getMonth() === now.getMonth() &&
      target.getDate() === now.getDate();
    if (sameDay) {
      var totalSeconds = Math.floor(diffMs / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var hh = String(hours).padStart(2, '0');
      var mm = String(minutes).padStart(2, '0');
      el.textContent = hh + ':' + mm + ' left to order!';
    } else {
      var nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var targetMidnight = new Date(target.getFullYear(), target.getMonth(), target.getDate());
      var days = Math.round((targetMidnight - nowMidnight) / 86400000);
      var dayLabel = days === 1 ? 'day' : 'days';
      el.textContent = days + ' ' + dayLabel + ' left to order!';
    }
  }

  document.querySelectorAll('.cm2-progress__deadline[data-window-closes-at]').forEach(function (el) {
    updateCommunityCountdown(el);
    setInterval(function () { updateCommunityCountdown(el); }, 30000);
  });

  // 5. Pre-launch lock (ENG-2160). Liquid renders the disabled button + the
  // "Orders open <date>" notice(s) only while window_opens_at is in the
  // future (server-side check). This re-checks continuously in the browser
  // and is authoritative: it unlocks the page the moment the real opens_at
  // passes, even on a copy of the page that was cached before opening and
  // is now being served stale (the server-rendered "locked" markup is only
  // ever a first-paint fallback, not the source of truth).
  function formatOpensDate(target) {
    return target.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
  }

  // Duration-based, not calendar-date-based: windows always open at local
  // midnight (shared/community.ts windowOpensISO in the self-serve repo), so
  // "is target the same calendar day as now, in the viewer's own timezone"
  // is never true before opening — the viewer is always on the calendar day
  // BEFORE the target's, right up until it opens. That bug made this show
  // "1 day to go" at 11:58pm the night before, instead of counting down the
  // last couple of minutes in hours/minutes.
  function opensCountdownText(target, now) {
    var totalMinutes = Math.floor((target.getTime() - now.getTime()) / 60000);
    var days = Math.floor(totalMinutes / 1440);
    if (days >= 1) {
      return days + ' ' + (days === 1 ? 'day' : 'days');
    }
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    if (hours > 0) {
      return hours + 'h ' + minutes + 'm';
    }
    return minutes + 'm';
  }

  // Updates every .cm2-prelaunch notice in place (there can be two: the
  // main-point banner and the buy-box one). Each wraps a .cm2-prelaunch__text
  // element (rewritten every tick) and an FAQ link (a sibling, untouched by
  // that rewrite -- only removed, link included, once the window opens, via
  // el.remove() on the whole container). Returns true if any are still
  // locked, so the caller knows whether to keep polling.
  function updatePrelaunchNotices() {
    var stillLocked = false;
    document.querySelectorAll('.cm2-prelaunch[data-window-opens-at]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-window-opens-at'));
      if (isNaN(target.getTime())) return;
      var now = new Date();
      if (target.getTime() <= now.getTime()) {
        el.remove();
        return;
      }
      stillLocked = true;
      var textEl = el.querySelector('.cm2-prelaunch__text') || el;
      textEl.textContent =
        'Orders open ' + formatOpensDate(target) + ' (' + opensCountdownText(target, now) + ' to go)';
    });
    return stillLocked;
  }

  // The ATC form is hidden entirely while locked (not relabeled) so the
  // "orders open" message doesn't show twice back to back with the notice
  // above it. Separate from updatePrelaunchNotices because the form can
  // exist with no notice nearby (and vice versa isn't expected, but each
  // checks its own data-window-opens-at independently rather than assuming
  // the other is present).
  function updatePrelaunchForm() {
    var wrapper = document.querySelector('[data-prelaunch-form][data-window-opens-at]');
    if (!wrapper) return false;
    var target = new Date(wrapper.getAttribute('data-window-opens-at'));
    if (isNaN(target.getTime())) return false;
    if (target.getTime() <= new Date().getTime()) {
      wrapper.hidden = false;
      wrapper.removeAttribute('data-window-opens-at');
      return false;
    }
    return true;
  }

  if (document.querySelector('[data-window-opens-at]')) {
    var prelaunchTick = function () {
      var locked = updatePrelaunchNotices();
      var formLocked = updatePrelaunchForm();
      return locked || formLocked;
    };
    if (prelaunchTick()) {
      var prelaunchInterval = setInterval(function () {
        if (!prelaunchTick()) clearInterval(prelaunchInterval);
      }, 30000);
      // Background tabs can throttle setInterval to roughly once a minute, so
      // someone who opened the page and tabbed away could stay locked for up
      // to that long after the real opening moment. Re-check immediately the
      // moment the tab regains focus, instead of waiting for the next tick.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        if (!prelaunchTick()) clearInterval(prelaunchInterval);
      });
    }
  }
})();
